import { hasDatePassed } from './date';

describe('Date utilities', function () {
    beforeEach(() => {
        // Mock Date.now() to return a consistent timestamp for testing
        // Using 2024-06-15T14:00:00 CET (which is 2024-06-15T12:00:00 UTC in summer time)
        // CET is UTC+1 in winter, CEST (summer) is UTC+2
        jasmine.clock().install();
        jasmine.clock().mockDate(new Date('2024-06-15T12:00:00Z')); // 14:00 CEST
    });

    afterEach(() => {
        jasmine.clock().uninstall();
    });

    it('Should interpret date without timezone as CET and detect it has passed', function () {
        // This time is 13:00 CEST (11:00 UTC), which is before our mocked "now" (14:00 CEST = 12:00 UTC)
        const pastDate = '2024-06-15T13:00:00';
        expect(hasDatePassed(pastDate)).toBe(true);
    });

    it('Should interpret date without timezone as CET and detect it has not passed', function () {
        // This time is 15:00 CEST (13:00 UTC), which is after our mocked "now" (14:00 CEST = 12:00 UTC)
        const futureDate = '2024-06-15T15:00:00';
        expect(hasDatePassed(futureDate)).toBe(false);
    });

    it('Should respect timezone when explicitly provided with Z (UTC)', function () {
        // 11:00 UTC is before 12:00 UTC (our mocked now)
        const pastDate = '2024-06-15T11:00:00Z';
        expect(hasDatePassed(pastDate)).toBe(true);

        // 13:00 UTC is after 12:00 UTC (our mocked now)
        const futureDate = '2024-06-15T13:00:00Z';
        expect(hasDatePassed(futureDate)).toBe(false);
    });

    it('Should respect timezone when explicitly provided with offset', function () {
        // 14:00+02:00 is 12:00 UTC, exactly at our mocked now
        const exactDate = '2024-06-15T14:00:00+02:00';
        expect(hasDatePassed(exactDate)).toBe(false);

        // 13:59+02:00 is 11:59 UTC, before our mocked now
        const pastDate = '2024-06-15T13:59:00+02:00';
        expect(hasDatePassed(pastDate)).toBe(true);
    });

    it('Should work with Date objects', function () {
        const pastDate = new Date('2024-06-15T11:00:00Z');
        expect(hasDatePassed(pastDate)).toBe(true);

        const futureDate = new Date('2024-06-15T13:00:00Z');
        expect(hasDatePassed(futureDate)).toBe(false);
    });

    it('Should handle winter time (CET = UTC+1)', function () {
        // Mock to January when CET is UTC+1 (not daylight saving)
        jasmine.clock().mockDate(new Date('2024-01-15T12:00:00Z')); // 13:00 CET

        // 12:00 CET (11:00 UTC) is before our mocked "now" (13:00 CET = 12:00 UTC)
        const pastDate = '2024-01-15T12:00:00';
        expect(hasDatePassed(pastDate)).toBe(true);

        // 14:00 CET (13:00 UTC) is after our mocked "now" (13:00 CET = 12:00 UTC)
        const futureDate = '2024-01-15T14:00:00';
        expect(hasDatePassed(futureDate)).toBe(false);
    });

    it('Should handle dates with milliseconds', function () {
        // 13:00:00.500 CEST (11:00:00.500 UTC) is before our mocked "now" (14:00 CEST = 12:00 UTC)
        const pastDate = '2024-06-15T13:00:00.500';
        expect(hasDatePassed(pastDate)).toBe(true);

        // 15:00:00.123 CEST (13:00:00.123 UTC) is after our mocked "now" (14:00 CEST = 12:00 UTC)
        const futureDate = '2024-06-15T15:00:00.123';
        expect(hasDatePassed(futureDate)).toBe(false);
    });
});
